import { Button, Typography } from "@mui/material";
import { Fragment, useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "./video-ai.css";

import { IoMdSend } from "react-icons/io";

import axios from "axios";
import ReactMarkdown from "react-markdown";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import PageHeading from "../../Components/PageHeading/PageHeading";
import {
  handleAiChatCompletionsVideo,
  handleAiChatCompletions,
} from "../../utils/AiApiFunctions";
import Timer from "react-compound-timer/build";
import { formatTime } from "../../utils/formatTimer";
import swal from "sweetalert";
import CreditsButton from "../../utils/CreditsButton";
import reload from "../../Assets/Images/relaoder.png";


const VideoAiApp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [randomQuestion, setRandomQuestion] = useState('');

  // Function to get a random question
  const getRandomQuestion = () => {
    const questions = [
      "The Ultimate Guide to Productivity Hacks",
      "Exploring Hidden Gems: Off the Beaten Path Travel Destinations",
      "DIY Home Renovation: Transforming Spaces on a Budget",
      "Mastering the Art of Photography: Tips and Techniques",
      "Healthy Cooking Made Easy: Delicious Recipes for Every Meal",
      "Unboxing the Latest Tech Gadgets: Reviews and First Impressions",
      "Mindfulness Meditation for Beginners: Finding Inner Peace",
      "10-Minute Workouts for Busy Lifestyles",
      "How to Start a Successful Online Business from Scratch",
      "Mystery Box Challenge: Can You Guess What's Inside?",
      "Thrift Store Haul: Finding Treasures on a Budget",
      "The Psychology of Success: Unlocking Your Full Potential",
      "Adventures in Urban Exploration: Discovering Abandoned Places",
      "Beginner's Guide to Investing in the Stock Market",
      "Crafting with Recycled Materials: Eco-Friendly DIY Projects",
      "Travel Vlogs: Exploring Exotic Destinations Around the World",
      "Transform Your Style: Fashion Tips and Wardrobe Makeovers",
      "The Science of Happiness: Strategies for a Fulfilling Life",
      "Digital Art Showcase: Inspiring Creations from Talented Artists",
      "Behind the Scenes: The Making of a Blockbuster Movie",
      "Solving Mysteries: True Crime Investigations Uncovered",
      "Vegan Cooking 101: Delicious Plant-Based Recipes",
      "Gaming Challenges: Can You Beat the Toughest Levels?",
      "Mind-Blowing Magic Tricks Revealed",
      "Self-Care Sundays: Relaxation Techniques for a Stress-Free Week",
      "Documentary Series: Exploring Fascinating Historical Events",
      "Makeup Tutorials for Every Occasion",
      "The Art of Calligraphy: Mastering Beautiful Handwriting",
      "Extreme Sports Adventures: Adrenaline-Pumping Action",
      "Coding Bootcamp: Learn to Code Like a Pro",
      "Paranormal Investigations: Exploring Haunted Locations",
      "Outdoor Survival Skills: Wilderness Tips and Tricks",
      "DIY Beauty Products: Natural Remedies for Radiant Skin",
      "Mastering the Guitar: From Beginner to Rockstar",
      "Traveling on a Budget: Tips for Affordable Adventures",
      "The Future of Technology: Innovations That Will Change the World",
      "Exploring Cultural Cuisine: Tasting Foods from Around the Globe",
      "Psychology Experiments: Understanding the Human Mind",
      "Thriller Book Club: Analyzing the Best-Selling Page-Turners",
      "Art Therapy: Healing Through Creative Expression",
      "Dance Workouts: Fun and Fitness Combined",
      "Exploring the Unknown: Unsolved Mysteries of the World",
      "Urban Gardening: Tips for Growing Your Own Food in the City",
      "DIY Fashion: Upcycling Old Clothes into Trendy Outfits",
      "Becoming a Minimalist: Simplify Your Life and Find Happiness",
      "Virtual Reality Adventures: Immersive Gaming Experiences",
      "Ghost Hunting Expeditions: Searching for Spirits in Spooky Places",
      "Investing in Cryptocurrency: Understanding the Digital Market",
      "Exploring Underwater Worlds: Scuba Diving Adventures",
      "Feng Shui Your Space: Tips for a Harmonious Home"
    ];

    const randomIndex = Math.floor(Math.random() * questions.length);
    return questions[randomIndex];
  };

  // Set random question when component mounts
  useEffect(() => {
    setRandomQuestion(getRandomQuestion());
  }, []);

  const {
    AIuser,
    userRefetch,
    setUserRefetch,
    isBack,
    setTokenLocal,
    setisBack,
    setInitialTimer,
  } = useContext(UserAuthContext);

  const [inputText, setInputText] = useState(
    ""
  );
  const [enableOwnScript, setEnableOwnScript] = useState(false)
  const [generatedText, setGeneratedText] = useState(
    "Artificial Intelligence (AI) is a rapidly growing field of technology that is revolutionizing the way we interact with the world. AI is the ability of a computer or machine to think and learn like a human. It is a form of intelligence that is based on algorithms and data, rather than on human intelligence.\n\n\nAI is used in a variety of applications, from self-driving cars to medical diagnosis. AI is used to automate tasks that would otherwise require human intelligence. For example, AI can be used to analyze large amounts of data and make decisions based on the data. AI can also be used to recognize patterns in data and make predictions about future events.\n\n\nAI can also be used to create virtual assistants that can respond to user queries and provide helpful information. AI is also being used to create robots that can interact with humans in a more natural way. These robots can be used to perform tasks such as cleaning, cooking, and providing companionship.\n\n\nAI is also being used to create virtual reality experiences that can be used for entertainment or educational purposes. AI is also being used to create autonomous vehicles that can drive themselves. These vehicles are being developed to reduce the number of accidents on the road and to make transportation more efficient.\n\n\nAI is also being used to create autonomous drones that can be used for surveillance or delivery purposes. AI is also being used to create intelligent machines that can understand natural language and respond to user queries. These machines can be used to provide customer service or to provide information about products and services.\n\n\nAI is also being used to create intelligent robots that can interact with humans in a more natural way. AI is a rapidly growing field of technology that is revolutionizing the way we interact with the world. AI is being used in a variety of applications, from self-driving cars to medical diagnosis. AI is also being used to create autonomous vehicles, robots, and intelligent machines that can understand natural language and respond to user queries. AI is a powerful tool that is being used to create a more efficient and safer world."
  );

  const [isLoading, setIsLoading] = useState(false);
  const { token } = useParams();

  useEffect(() => {
    if (token) {

      localStorage.setItem("aiUser", token)
      setTokenLocal(token)

    }
  }, [userRefetch, token, AIuser]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (location?.state?.back && isBack) {
      const backText = location?.state?.text;
      const backInput = location?.state?.inputText;
      setInputText(backInput);
      setGeneratedText(backText);
    }
    // const isBack = location?.state?.back;
  }, [location, isBack]);

  useEffect(() => {
    if (location.state !== null) {
      setInputText(location.state.requestQues);
      setGeneratedText(location.state.response);
    }
  }, [location.state]);

  const handleSubmitCredits = async (e) => {
    const deductedCredits = AIuser.credits - 500;

    // console.log("question", question, conversation);
    await axios
      .put(
        "https://backend.whalesai.com/api/dashboard/user_signup-signin/update-credits",
        { email: AIuser?.email, credits: deductedCredits },
        {
          headers: {
            authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setUserRefetch(!userRefetch);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [timer, setTimer] = useState(0);

  useEffect(() => {
    let interval;
    if (isLoading) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer + 1);
        setInitialTimer((prevTimer) => prevTimer + 1);
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [isLoading, setInitialTimer]);

  const time = timer;



  // const splitParagraphs = (text) => {
  //   const MIN_SENTENCE_LENGTH = 7;
  //   const sentences = text?.split(/([.?!]|:)+/);
  //   let output = [];
  //   let buffer = "";

  //   for (let i = 0; i < sentences?.length; i++) {
  //     const sentence = sentences[i];
  //     buffer += sentence.trim();

  //     if (sentence.match(/[.?!:]/)) {
  //       if (buffer?.length >= MIN_SENTENCE_LENGTH ) {
  //         output.push(buffer);
  //         buffer = "";
  //       } else {
  //         if (i < sentences?.length - 1) {
  //           buffer += sentences[i + 1];
  //           i++;
  //         } else {
  //           output.push(buffer);
  //           buffer = "";
  //         }
  //       }
  //     }
  //   }
  //   if (buffer?.length > 0) {
  //     output.push(buffer);
  //   }

  //   const objArr = output?.map((text, index) => {
  //     return { text, id: index + 1, textAlign: "center" };
  //   });

  //   objArr?.unshift({
  //     text: inputText,
  //     id: 0,
  //     textAlign: "center",
  //   });
  //   // setPages(objArr);
  //   return objArr;
  // };


  // const splitParagraphs = (text) => {
  //   const MAX_CHARACTER_COUNT = 160;
  //   const MIN_SENTENCE_LENGTH = 10;
  //   const MIN_CHARACTER_COUNT = 80;
  //   const sentences = text?.split(/([.?!]|:)+/);
  //   let output = [];
  //   let buffer = "";
  //   let previousPunctuation = ""; // Track the previous punctuation symbol

  //   for (let i = 0; i < sentences?.length; i++) {
  //     const sentence = sentences[i];
  //     const remainingCharacters = MAX_CHARACTER_COUNT - buffer.length;

  //     if (sentence.length <= remainingCharacters) {
  //       buffer += sentence;
  //     } else {
  //       if (buffer.length >= MIN_SENTENCE_LENGTH) {
  //         output.push(buffer);
  //       }
  //       buffer = sentence;

  //       while (buffer.length >= MIN_SENTENCE_LENGTH) {
  //         if (buffer.length <= MAX_CHARACTER_COUNT) {
  //           output.push(buffer);
  //           buffer = "";
  //         } else {
  //           let currentSegment = buffer.substring(0, MAX_CHARACTER_COUNT);
  //           let lastSpaceIndex = currentSegment.lastIndexOf(" ");

  //           if (lastSpaceIndex !== -1) {
  //             while (currentSegment.length - lastSpaceIndex > MAX_CHARACTER_COUNT - MIN_CHARACTER_COUNT) {
  //               currentSegment = currentSegment.substring(0, lastSpaceIndex);
  //               lastSpaceIndex = currentSegment.lastIndexOf(" ");
  //             }
  //           } else {
  //             currentSegment = currentSegment.substring(0, MAX_CHARACTER_COUNT);
  //           }

  //           // Add necessary punctuation to the previous segment if needed
  //           if (previousPunctuation !== "" && /[.?!]/.test(currentSegment.charAt(currentSegment.length - 1))) {
  //             output[output.length - 1] += previousPunctuation;
  //           }

  //           output.push(currentSegment);
  //           buffer = buffer.substring(currentSegment.length);
  //           previousPunctuation = /[.?!]/.test(buffer.charAt(0)) ? buffer.charAt(0) : "";
  //         }
  //       }
  //     }
  //   }

  //   if (buffer.length >= MIN_SENTENCE_LENGTH) {
  //     output.push(buffer);
  //   }

  //   // Add the last sentence
  //   const lastSentence = "Thanks for watching. Please follow us.";
  //   output.push(lastSentence);

  //   const objArr = output?.map((text, index) => {
  //     const formattedText = text.replace(/^[.?!:,]/, '');
  //     return { text: formattedText, id: index + 1, textAlign: "center" };
  //   });

  //   objArr?.unshift({
  //     text: inputText,
  //     id: 0,
  //     textAlign: "center",
  //   });

  //   // Remove punctuation from the last segment if it's incomplete
  //   if (previousPunctuation !== "" && objArr.length > 0) {
  //     const lastSegment = objArr[objArr.length - 1];
  //     const lastCharacter = lastSegment.text.charAt(lastSegment.text.length - 1);

  //     if (lastSegment.text.length < MIN_SENTENCE_LENGTH) {
  //       lastSegment.text = lastSegment.text.replace(/[.?!]$/, '');
  //     } else if (!/[.?!]/.test(lastCharacter)) {
  //       lastSegment.text += previousPunctuation;
  //     }
  //   }

  //   return objArr;
  // };

  const splitParagraphs = (text) => {
    const MAX_CHARACTER_COUNT = 160;
    const MIN_SENTENCE_LENGTH = 10;
    const MIN_CHARACTER_COUNT = 80;
    const sentences = text?.match(/[^.!?]+[.!?]+/g); // Match complete sentences
    let output = [];
    let buffer = "";

    for (let i = 0; i < sentences?.length; i++) {
      const sentence = sentences[i];
      const remainingCharacters = MAX_CHARACTER_COUNT - buffer.length;

      if (sentence.length <= remainingCharacters) {
        buffer += sentence;
      } else {
        if (buffer.length >= MIN_SENTENCE_LENGTH) {
          output.push(buffer);
        }
        buffer = sentence;

        while (buffer.length >= MIN_SENTENCE_LENGTH) {
          if (buffer.length <= MAX_CHARACTER_COUNT) {
            output.push(buffer);
            buffer = "";
          } else {
            let currentSegment = buffer.substring(0, MAX_CHARACTER_COUNT);
            let lastSpaceIndex = currentSegment.lastIndexOf(" ");

            if (lastSpaceIndex !== -1) {
              while (currentSegment.length - lastSpaceIndex > MAX_CHARACTER_COUNT - MIN_CHARACTER_COUNT) {
                currentSegment = currentSegment.substring(0, lastSpaceIndex);
                lastSpaceIndex = currentSegment.lastIndexOf(" ");
              }
            } else {
              currentSegment = currentSegment.substring(0, MAX_CHARACTER_COUNT);
            }

            output.push(currentSegment);
            buffer = buffer.substring(currentSegment.length);
          }
        }
      }
    }

    if (buffer.length >= MIN_SENTENCE_LENGTH) {
      output.push(buffer);
    }

    // Add the last sentence
    const lastSentence = "Thanks for watching. Please follow us.";
    output.push(lastSentence);

    const objArr = output?.map((text, index) => {
      const formattedText = text.replace(/^[.?!:,]/, '').trim();
      return { text: formattedText, id: index + 1, textAlign: "center" };
    });

    objArr?.unshift({
      text: inputText,
      id: 0,
      textAlign: "center",
    });

    return objArr;
  };





  const splitParagraphs1 = (inputText) => {
    const MAX_CHARACTER_COUNT = 160;
    const MIN_SENTENCE_LENGTH = 10;
    const MIN_CHARACTER_COUNT = 80;
    const sentences = inputText?.split(/([.?!]|:)+/);
    let output = [];
    let buffer = "";
    let previousPunctuation = ""; // Track the previous punctuation symbol

    for (let i = 0; i < sentences?.length; i++) {
      const sentence = sentences[i];
      const remainingCharacters = MAX_CHARACTER_COUNT - buffer.length;

      if (sentence.length <= remainingCharacters) {
        buffer += sentence;
      } else {
        if (buffer.length >= MIN_SENTENCE_LENGTH) {
          output.push(buffer);
        }
        buffer = sentence;

        while (buffer.length >= MIN_SENTENCE_LENGTH) {
          if (buffer.length <= MAX_CHARACTER_COUNT) {
            output.push(buffer);
            buffer = "";
          } else {
            let currentSegment = buffer.substring(0, MAX_CHARACTER_COUNT);

            // Move substring end position back until we find the last space
            while (currentSegment[currentSegment.length - 1] !== " ") {
              currentSegment = currentSegment.substring(0, currentSegment.length - 1);
            }

            // Add necessary punctuation to the previous segment if needed
            if (previousPunctuation !== "" && /[.?!]/.test(currentSegment.charAt(currentSegment.length - 1))) {
              output[output.length - 1] += previousPunctuation;
            }

            output.push(currentSegment);
            buffer = buffer.substring(currentSegment.length);
            previousPunctuation = /[.?!]/.test(buffer.charAt(0)) ? buffer.charAt(0) : "";
          }
        }
      }
    }

    if (buffer.length >= MIN_SENTENCE_LENGTH) {
      output.push(buffer);
    }

    // Add the last sentence
    const lastSentence = "Thanks for watching. Please follow us.";
    output.push(lastSentence);

    const objArr = output?.map((text, index) => {
      const formattedText = text.replace(/^[.?!:,]/, '');
      return { text: formattedText, id: index + 1, textAlign: "center" };
    });

    // Remove the first element from the objArr array
    // objArr.shift();

    // Remove punctuation from the last segment if it's incomplete
    if (previousPunctuation !== "" && objArr.length > 0) {
      const lastSegment = objArr[objArr.length - 1];
      const lastCharacter = lastSegment.text.charAt(lastSegment.text.length - 1);

      if (lastSegment.text.length < MIN_SENTENCE_LENGTH) {
        lastSegment.text = lastSegment.text.replace(/[.?!]$/, '');
      } else if (!/[.?!]/.test(lastCharacter)) {
        lastSegment.text += previousPunctuation;
      }
    }

    return objArr;
  };





  // const output = splitParagraphs(text);

  // useEffect(() => {

  //     const output = splitParagraphs(text);
  //     output?.unshift({
  //       text: location?.state?.inputText,
  //       id: 0,
  //       textAlign: "center",
  //     });
  //     setPages(output);

  // }, []);


  // useEffect(() => {
  //   // wait 5 seconds and navigate to videoai page
  //   setTimeout(() => {
  //     navigate("/generated-video", {
  //       state: {
  //         text: location?.state?.text,
  //         paragraphs: location.state.paragraphs,
  //         transactionId: location?.state?.transactionId,
  //         format: selectedCheckboxIndex,
  //       },
  //     });
  //   }, 5000);
  // }, [
  //   location.state?.inputText,
  //   location.state?.text,
  //   location.state?.paragraphs,
  //   selectedCheckboxIndex,
  //   navigate,
  //   location?.state?.transactionId,
  // ]);



  const ConfirmVideo = async () => {
    if (AIuser.credits > 500) {
      const wrapper = document.createElement("div");
      wrapper.innerHTML = `<p></p> <p class="text-white">Video AI will create the video within 240 seconds. Please do not close this browser. <br/> <span class="text-warning"> Do you want to proceed?</span></p> `;
      return swal({
        content: wrapper,
        icon: "success",
        buttons: ["No", "Yes"],
        className: "modal_class_success",
      }).then(async function (isConfirm) {
        if (isConfirm) {
          // await handleGenerateText();

          setGeneratedText("");
          setIsLoading(true);
          // back = false;

          const response = await handleAiChatCompletionsVideo(
            "Write a 300 words article about" +
            " " +
            inputText + ", every single sentence must be less then 20 words and no need to use numbering for this article." +
            " " +
            "Dont give any links or references",
            "videoai"
          );

          if (response) {
            setGeneratedText(response);
            handleSubmitCredits();

            const randomChars =
              "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz01234567891011121314156655";
            let transactionId = "";
            for (let i = 0; i < 8; i++) {
              transactionId += randomChars.charAt(
                Math.floor(Math.random() * randomChars.length)
              );
            }

            const transactionRes = await axios.post(
              "https://backend.whalesai.com/api/v1/credits-transaction/create",
              {
                aiType: "Video Ai",
                transactionId: transactionId,
                requestQues: `${inputText}`,
                response: response,
                credit: 500,
                userId: AIuser?._id,
              }
            );

            if (response) {
              const paragraphs = splitParagraphs(response)


              navigate("/generated-video", {
                state: {
                  text: response,
                  paragraphs: paragraphs,
                  transactionId: transactionId,

                },
              });
              setisBack(false);

              setIsLoading(false);
            } else {
              // setIsLoading(true)
            }
          } else {
            setGeneratedText("Invalid prompt!");
          }
        } else {
          console.log("");
        }
      });
    } else {
      swal({
        text: "You don't have enough credits! Please buy credits to continue.",

        icon: "error",
        buttons: "Ok",
        className: "modal_class_success",
      }).then((value) => {
        if (value) {
          navigate("/purchase");
        }
      });
    }

    // const handleGenerateText = async () => {
    //   // setInputText("");

    // };
  };
  const createOwnScript = () => {
    console.log('DIFF FUNC CALLED')

    if (AIuser.credits > 500) {
      const wrapper = document.createElement("div");
      wrapper.innerHTML = `<p></p> <p class="text-white">Video AI will create the video within 240 seconds. Please do not close this browser. <br/> <span class="text-warning"> Do you want to proceed?</span></p> `;
      return swal({
        content: wrapper,
        icon: "success",
        buttons: ["No", "Yes"],
        className: "modal_class_success",
      }).then(async function (isConfirm) {
        if (isConfirm) {
          const randomChars =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz01234567891011121314156655";
          let transactionId = "";
          for (let i = 0; i < 8; i++) {
            transactionId += randomChars.charAt(
              Math.floor(Math.random() * randomChars.length)
            );
          }
          const paragraphs = splitParagraphs1(inputText)
          navigate("/generated-video", {
            state: {
              text: inputText,
              paragraphs: paragraphs,
              transactionId: transactionId,
              uniqeId: 123,
            },
          });
          setisBack(false);
          setIsLoading(false);
        } else {
          console.log("");
        }
      });
    } else {
      swal({
        text: "You don't have enough credits! Please buy credits to continue.",
        icon: "error",
        buttons: "Ok",
        className: "modal_class_success",
      }).then((value) => {
        if (value) {
          navigate("/purchase");
        }
      });
    }
  }


  // const handleNavigate = () => {
  //   navigate("/format-script", {
  //     state: {
  //       text: generatedText,
  //       inputText: inputText,
  //       paragraphs: location?.state?.paragraphs,
  //     },
  //   });
  //   setisBack(false);
  // };

  return (
    <Fragment>
      <PageHeading title={"VIDEO AI"} />
      <div className="img-ai-container container pb-5">
        <div
          style={{
            maxWidth: "872px",
            paddingInline: "12px",
            marginInline: "auto",
          }}
        >
          <div className="d-flex align-items-center justify-content-center centralize-credits-btn-sm">
            <div className="d-flex ">
              <CreditsButton />

            </div>
          </div>
          <p className="text-white text-center mt-2 mb-0 centralize-credits-btn-sm">
            Every request is 500 credits.
          </p>

          {/* { timer > 0 && ( */}
          <div>
            {/* {timer && ( */}
            <div className="d-flex mt-3 justify-content-center ">
              <button className={`credits-button text-center text-uppercase mt-sm-0 mt-2 me-sm-2 me-0 test-class ${isLoading && "animate-timer-button"}`}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                {formatTime(timer).hours}
                {": "}
                {formatTime(timer).minutes}
                {":"}
                {formatTime(timer).seconds}
              </button>
            </div>
            {/* )} */}
            <p
              style={{ fontSize: "13px" }}
              className="text-center pt-2 text-to-animate"
            >
              Please do not move away from this browser.
              <br className="videoai-br-hide" /> Processing will stop.
            </p>
          </div>
        </div>

        <div className="container pt-3">
          <div style={{ maxWidth: "850px" }} className="mx-auto">

            {/* <p className="text-white centralize-credits-btn-sm">
              {`${enableOwnScript ? "Enter your own script (max 600 words)." : "Enter Title of Video you want to generate."}`}
            </p> */}
            <div
              className="ai-send-text mt-2 position-relative"
              style={{ marginBottom: 10, paddingBottom: "23px" }}
            >
              <form
              // onSubmit={handleSubmit}
              >
                <div className="d-flex justify-content-between align-items-end">
                  <textarea
                    className={`bg-transparent border-0 w-100 text-white ask-ai-fonts  ai-textarea ${!enableOwnScript && "text-uppercase"}`}
                    type="text"
                    lang="en"
                    placeholder=""
                    value={inputText}
                    id="inputText"
                    name="inputBox"
                    rows={enableOwnScript ? 8 : 2}
                    onChange={(e) => {
                      if (enableOwnScript && e.target.value.split(/\s+/).length <= 600) {
                        setInputText(e.target.value);
                        setGeneratedText("");
                      }
                      if (!enableOwnScript) {
                        setInputText(e.target.value);
                        setGeneratedText("");
                      }
                    }}
                  />
                  <div
                    className="ai-sent-item d-flex justify-content-end align-items-end "
                    type="submit"
                    // disabled={inputText?.length === 0}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <IoMdSend className="ask-ai-sent" onClick={!enableOwnScript ? ConfirmVideo : createOwnScript} />
                  </div>
                </div>
              </form>

              {inputText && enableOwnScript && (
                <p
                  className={`mb-0 text-white me-auto ${inputText?.split(/\s+/).length == 600 && "text-danger"
                    }`}
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    letterSpacing: "0.1px",
                    position: "absolute",
                    right: "17px",
                    bottom: "9px"
                  }}
                >
                  {inputText?.split(/\s+/).length}/600 words
                </p>
              )}

              {isLoading == true && <p
                class="text- mb-0"
                style={{
                  fontSize: "14px",
                  color: "lightblue",
                  position: "absolute",
                  left: "17px",
                  bottom: "9px"
                }}>
                Processing...
              </p>}
            </div>
            {!enableOwnScript && <div className="d-flex justify-content-between align-items-center">
              <p onClick={() => setInputText(randomQuestion)} style={{ cursor: "pointer" }} className="text-start text-warning"><span className="text-danger">Example:</span> {randomQuestion}</p>
              {/* <p onClick={()=> setRandomQuestion(getRandomQuestion())} style={{cursor:"pointer"}} className="text-start text-warning">Re</p> */}
              <img onClick={() => setRandomQuestion(getRandomQuestion())} style={{ cursor: "pointer" }} src={reload} alt="reload" width="30" height="30" />

            </div>}

            <div className="clearBtn">
              <button
                className="cancel-button"
                onClick={() => {
                  setInputText("");
                  setGeneratedText("");
                }}
              >
                CLEAR
              </button>
            </div>
            {!enableOwnScript ? <p onClick={() => setEnableOwnScript(true)} style={{ cursor: "pointer" }} className="text-md-start text-lg-start text-center text-white">Please click here to enter your own script.</p>
              :
              <p onClick={() => setEnableOwnScript(false)} style={{ cursor: "pointer" }} className="text-md-start text-lg-start text-center text-white">Please click here to let AI generate for you.</p>}

            {/* {inputText && (
              <div className="">
                <p
                  className="w-100 text-white p-3 text-start "
                  style={{
                    background: "#011C34",
                    borderRadius: "10px",
                    border: "1px solid #fff",
                  }}
                >
                  <>
                    <>
                      <p class="text-  text-light text-uppercase">
                        {inputText}
                      </p>

                      {isLoading == true ? (
                        <p
                          class="text- mb-0 mt-2"
                          style={{
                            fontSize: "14px",
                            color: "lightblue",
                          }}
                        >
                          Processing...
                        </p>
                      ) : (
                        <>
                          {generatedText && (
                            <p
                              style={{
                                color: "lightblue",
                              }}
                              class="text- mb-0 text-"
                              // dangerouslySetInnerHTML={{ __html: generatedText }}
                            >
                              <ReactMarkdown>{generatedText}</ReactMarkdown>
                            </p>
                          )}
                        </>
                      )}
                    </>
                  </>
                </p>
              </div>
            )} */}

            <div className="btnvideoDiv">
              {/*<button
                disabled={!generatedText || isLoading === true}
                onClick={() => {
                  handleNavigate();
                  setisBack(false);
                }}
                className={`${
                  !generatedText || isLoading === true ? "bg-dark" : ""
                } videoai_btn`}
              >
                Step 2: Format the Script
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default VideoAiApp;
